module.exports = __webpack_public_path__ + "static/img/photo6.83502e94.jpg";